import { render } from "./roster_field.vue?vue&type=template&id=354c8a6e&scoped=true"
import script from "./roster_field.vue?vue&type=script&lang=js"
export * from "./roster_field.vue?vue&type=script&lang=js"

import "./roster_field.vue?vue&type=style&index=0&id=354c8a6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354c8a6e"]])

export default __exports__